'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UploadStatusBaseClass = require('./UploadStatusBaseClass');

var _UploadStatusBaseClass2 = _interopRequireDefault(_UploadStatusBaseClass);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactI18next = require('react-i18next');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./FineUploader.scss');

var cn = _bind2.default.bind(styles);

var ProgressBar = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProgressBar, _Component);

  function ProgressBar() {
    var _ref;

    (0, _classCallCheck3.default)(this, ProgressBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressBar.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar)).call.apply(_ref, [this].concat(args)));

    _this.state = { progressTime: [] };
    _this.progressTimer = null;
    return _this;
  }

  (0, _createClass3.default)(ProgressBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(ProgressBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar.prototype), 'componentDidMount', this).call(this);
      this.startProgressTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(ProgressBar.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProgressBar.prototype), 'componentWillUnmount', this).call(this);
      this.stopProgressTimer();
    }
  }, {
    key: 'onUpdateProgress',
    value: function onUpdateProgress() {
      this.startProgressTimer();
    }

    // time left calculated by average speed for last N seconds

  }, {
    key: 'getLeftForTime',
    value: function getLeftForTime(minTime, maxTime) {
      var _state = this.state,
          bytesUploaded = _state.bytesUploaded,
          totalSize = _state.totalSize,
          progressTime = _state.progressTime;

      var sizeLeft = totalSize - bytesUploaded;
      var stepsStored = progressTime.length;

      var res = 0;
      if (stepsStored > minTime) {
        var calcTime = Math.min(maxTime, stepsStored - 1);
        var bytesUploadedForTime = 0;

        for (var i = stepsStored; i > stepsStored - calcTime; i--) {
          bytesUploadedForTime += progressTime[i - 1].bytesUploadedForTick;
        }

        var speed = bytesUploadedForTime / calcTime;
        res = Math.max(sizeLeft / speed, 0);
      }
      return Math.round(res);
    }
  }, {
    key: 'startProgressTimer',
    value: function startProgressTimer() {
      if (this.props.showLeftTime && !this.progressTimer) {
        this.progressTimer = setInterval(this.updateProgressTime, 1000);
      }
    }
  }, {
    key: 'stopProgressTimer',
    value: function stopProgressTimer() {
      clearInterval(this.progressTimer);
      this.progressTimer = null;
    }
  }, {
    key: 'updateProgressTime',
    value: function updateProgressTime() {
      var _state2 = this.state,
          bytesUploaded = _state2.bytesUploaded,
          totalSize = _state2.totalSize,
          progressTime = _state2.progressTime;

      var newProgressTime = [].concat((0, _toConsumableArray3.default)(progressTime));

      if (bytesUploaded) {
        var bytesUploadedForTick = progressTime.length ? bytesUploaded - progressTime[progressTime.length - 1].bytesUploaded : 0;
        // if we cancel some uploads then bytesUploaded and totalSize will be very different from last stored, so compensate it
        if (bytesUploadedForTick < 0) {
          bytesUploadedForTick = progressTime.length ? progressTime[progressTime.length - 1].bytesUploadedForTick : 0;
        }

        newProgressTime.push({
          bytesUploaded: bytesUploaded,
          totalSize: totalSize,
          bytesUploadedForTick: bytesUploadedForTick
        });
      }

      var timeLeft = this.getLeftForTime(1, 20);

      if (timeLeft === 0) {
        this.stopProgressTimer();
      }

      if (newProgressTime.length > 30) {
        newProgressTime.splice(0, 1);
      }

      this.setState({ progressTime: newProgressTime, timeLeft: timeLeft });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className,
          timeLeftClass = _props.timeLeftClass,
          altStyle = _props.altStyle;
      var _state3 = this.state,
          progress = _state3.progress,
          hidden = _state3.hidden,
          isComplete = _state3.isComplete,
          isFailed = _state3.isFailed,
          isCanceled = _state3.isCanceled,
          isSuccess = _state3.isSuccess,
          timeLeft = _state3.timeLeft;

      var progressBarClass = (0, _bind2.default)('progressBar', className, styles.progressBar, this._isTotalProgress ? styles.total : styles.file, (0, _defineProperty3.default)({}, styles.altStyle, altStyle));
      var timeLeftStr = (0, _utils.secondsToTime)({ seconds: timeLeft, infinityStr: t('Calculating...') });

      return _react2.default.createElement(
        'div',
        { className: progressBarClass, hidden: hidden },
        _react2.default.createElement('s', { className: cn('progress', { isFailed: isFailed, isCanceled: isCanceled, isSuccess: isSuccess, isComplete: isComplete }), style: { width: progress ? progress + '%' : 0 } }),
        !!timeLeft && _react2.default.createElement(
          'div',
          { className: timeLeftClass },
          timeLeftStr
        )
      );
    }
  }]);
  return ProgressBar;
}(_UploadStatusBaseClass2.default), _class3.propTypes = {
  altStyle: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  showLeftTime: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  timeLeftClass: _propTypes2.default.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateProgressTime', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'updateProgressTime'), _class2.prototype)), _class2)) || _class);
exports.default = ProgressBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/ProgressBar.js
// module id = 1996
// module chunks = 1